import { createStoreWithSubscribe, createShallowStore } from '@frontend/store';

type ReadFilter = boolean | undefined;

type RepliedFilter = boolean | undefined;

type SourceFilterType = 'google' | 'facebook' | 'private' | 'all-reviews';
interface ReviewFiltersStore {
  sourceFilter: SourceFilterType;
  readFilter: ReadFilter;
  repliedFilter: RepliedFilter;
  sortByNewest: boolean;
  startDate: string;
  endDate: string;
  canClearFilters: () => boolean;
  resetAllExceptSourceFilter: () => void;
  setSourceFilter: (sourceFilter: SourceFilterType) => void;
  setReadFilter: (readFilter: ReadFilter) => void;
  setRepliedFilter: (sourceFilter: RepliedFilter) => void;
  setSortByNewest: (sourceFilter: boolean) => void;
  setStartDate: (startDate: string) => void;
  setEndDate: (endDate: string) => void;
}

export const useReviewsFilterStore = createStoreWithSubscribe<ReviewFiltersStore>(
  (set, get) => ({
    sourceFilter: 'all-reviews',
    readFilter: undefined,
    repliedFilter: undefined,
    startDate: '',
    endDate: '',
    sortByNewest: true,
    canClearFilters: () => {
      return (
        !!get().startDate || !!get().endDate || get().readFilter !== undefined || get().repliedFilter !== undefined
      );
    },
    resetAllExceptSourceFilter: () => {
      set(
        (state) => {
          (state.readFilter = undefined),
            (state.repliedFilter = undefined),
            (state.startDate = ''),
            (state.endDate = ''),
            (state.sortByNewest = true);
        },
        false,
        'RESET_ALL_EXCEPT_SOURCE_FILTER'
      );
    },
    setSourceFilter: (sourceFilter: SourceFilterType) => {
      set(
        (state) => {
          state.sourceFilter = sourceFilter;
        },
        false,
        'SET_REVIEWS_SOURCE_FILTER'
      );
    },
    setStartDate: (startDate: string) => {
      set(
        (state) => {
          state.startDate = startDate;
        },
        false,
        'SET_REVIEWS_START_DATE'
      );
    },
    setEndDate: (endDate: string) => {
      set(
        (state) => {
          state.endDate = endDate;
        },
        false,
        'SET_REVIEWS_END_DATE'
      );
    },
    setReadFilter: (readFilter: ReadFilter) =>
      set(
        (state) => {
          state.readFilter = readFilter;
        },
        false,
        'SET_REVIEWS_READ_FILTER'
      ),
    setRepliedFilter: (repliedFilter: RepliedFilter) =>
      set(
        (state) => {
          state.repliedFilter = repliedFilter;
        },
        false,
        'SET_REVIEWS_REPLIED_FILTER'
      ),
    setSortByNewest: (sortByNewest: boolean) =>
      set(
        (state) => {
          state.sortByNewest = sortByNewest;
        },
        false,
        'SET_REVIEWS_SORT'
      ),
  }),
  { name: 'ReviewsFilterStore', trace: true }
);

export const useReviewsFilterShallowStore = createShallowStore(useReviewsFilterStore);
